const MESSAGE_HISTORY_START = '<|im_start|>'
const MESSAGE_HISTORY_ENTRY_PATTERN = /<\|im_start\|>([^\n]+)\n?([\s\S]*?)<\|im_end\|>/g
const MESSAGE_HISTORY_PREVIEW_MAX_LENGTH = 80

type PromptBodyMessageHistoryEntry = {
  role: string
  content: string
}

function parsePromptBodyMessageHistory(body: string): PromptBodyMessageHistoryEntry[] {
  if (!body.trimStart().startsWith(MESSAGE_HISTORY_START)) return []

  const entries: PromptBodyMessageHistoryEntry[] = []

  for (const match of body.matchAll(MESSAGE_HISTORY_ENTRY_PATTERN)) {
    const role = match[1]
    const content = match[2]

    if (!role || content === undefined) continue

    entries.push({
      role,
      content: content.replace(/^\n+|\n+$/g, ''),
    })
  }

  return entries
}

function getMessagePreview(content: string): string {
  const firstNonEmptyLine = content
    .split('\n')
    .map(line => line.trim())
    .find(line => line.length > 0)

  if (!firstNonEmptyLine) return ''
  if (firstNonEmptyLine.length <= MESSAGE_HISTORY_PREVIEW_MAX_LENGTH) return firstNonEmptyLine

  return `${firstNonEmptyLine.slice(0, MESSAGE_HISTORY_PREVIEW_MAX_LENGTH - 3)}...`
}

export function logPromptBody(body: string): void {
  const historyEntries = parsePromptBodyMessageHistory(body)

  if (historyEntries.length === 0) {
    // eslint-disable-next-line no-console
    console.log('Prompt Body:', body)
    return
  }

  // eslint-disable-next-line no-console
  console.groupCollapsed(`Prompt Body: Message History (${historyEntries.length} messages)`)

  for (const entry of historyEntries) {
    const preview = getMessagePreview(entry.content)
    const label = preview ? `Prompt Body: [${entry.role}] ${preview}` : `Prompt Body: [${entry.role}]`

    // eslint-disable-next-line no-console
    console.groupCollapsed(label)
    // eslint-disable-next-line no-console
    console.log(entry.content)
    // eslint-disable-next-line no-console
    console.groupEnd()
  }

  // eslint-disable-next-line no-console
  console.groupEnd()

  // eslint-disable-next-line no-console
  console.groupCollapsed('Prompt Body: Full Message History (raw)')
  // eslint-disable-next-line no-console
  console.log(body)
  // eslint-disable-next-line no-console
  console.groupEnd()
}
